import React from "react";
import App from "App";
import paths, { rootPaths } from "./paths";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";
import ErrorLayout from "../layouts/ErrorLayout";

import Dashboard from "components/dashboards/default";

import VerticalNavLayout from "layouts/VerticalNavLayout";
import TopNavLayout from "layouts/TopNavLayout";
import ComboNavLayout from "layouts/ComboNavLayout";
import DoubleTopNavLayout from "layouts/DoubleTopNavLayout";
import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";
import Login from "components/authentication/Login";
import AuthLayout from "layouts/AuthLayout";
import ForgotPassword from "components/authentication/ForgotPassword";
import ResetPassword from "components/authentication/ResetPassword";
import Logout from "components/authentication/Logout";
import LockScreen from "components/authentication/LockScreen";
import ConfirmMail from "components/authentication/ConfirmMail";
import EligibilityCheck from "features/eliglibility/eliglibility-check";
import RequiredAuth from "components/authentication/components/RequiredAuth";
import EligibilityCheckList from "features/eliglibility/eligibility-check-list";
import EliglibilityResposne from "features/eliglibility/eliglibility-check/components/EliglibilityResposne";
import Preauthorization from "features/preauthorization";
import PrauthorizationList from "features/preauthorization/components/PrauthorizationList";
import PrauthorizationView from "features/preauthorization/components/PrauthorizationView";
import Practitioners from "features/practitioner";
import AddPractitioner from "features/practitioner/components/AddPractitioner";
import PractitonerImport from "features/practitioner/components/PractitonerImport";
import PriceList from "features/price";
import AddPrice from "features/price/components/AddPrice";
import PriceImport from "features/price/components/PriceImport";
import BranchList from "features/branch";
import BranchImport from "features/branch/components/BranchImport";
import AddBranch from "features/branch/components/AddBranch";
import FieldSettings from "features/field-settings";
import UserPermissionList from "features/user-permission/UserPermissionList";
import EditUserPermission from "features/user-permission/components/EditUserPermission";
import EmpolyeeList from "features/empolyee";
import AddEmpolyee from "features/empolyee/components/AddEmpolyee";
import EmpolyeeImport from "features/empolyee/components/EmpolyeeImport";
import Cliams from "features/cliams";
import ClaimViewRequest from "features/cliams/components/ClaimViewRequest";
import PrepareClaim from "features/cliams/components/PrepareClaim";
import CliamViewResponse from "../features/cliams/components/view-claim/CliamViewResponse";
import CreateClaim from "../features/cliams/components/create-claim";
import ClaimDashboard from "../features/cliams/components/dashboard-claim/index.js";
import ClaimImport from "features/cliams/components/ClaimImport";
import ClaimPolls from "features/claim-polls";
import DashboardMain from "../features/dashboard";
import PaymentList from "features/cliams/components/payment/index";
import SystemPrivillageMain from "features/system-privillage/index";
import InsuranceCompanyList from "features/insurance-company/index";
import AddUpdateRole from "features/system-privillage/component/AddUpdateRole";
import Patient from "features/patient";
import PatientView from "features/patient/components/PatientView";
import UserProfile from "features/user-profile";
const routes = [
  {
    element: <App />,
    children: [
      // Public routes
      {
        path: rootPaths.authRoot,
        element: <AuthLayout />,
        children: [
          {
            index: true,
            element: <Login />,
          },
          {
            path: paths.login,
            element: <Login />,
          },
          {
            path: paths.forgotPassword,
            element: <ForgotPassword />,
          },
          {
            path: paths.resetPassword,
            element: <ResetPassword />,
          },
          {
            path: paths.resetPassword + "/endpoint",
            element: <ResetPassword />,
          },
          {
            path: paths.logout,
            element: <Logout />,
          },
          {
            path: paths.lockScreen,
            element: <LockScreen />,
          },
          {
            path: paths.confirmMail,
            element: <ConfirmMail />,
          },
        ],
      },
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />,
          },
          {
            path: paths.error500,
            element: <Error500 />,
          },
        ],
      },

      // Protected routes
      {
        element: <RequiredAuth />, // Authentication wrapper
        children: [
          // Main application layout
          {
            path: "/",
            element: <MainLayout />,
            children: [
              {
                index: true,
                element: <DashboardMain />,
              },
              {
                path: paths.profile,
                element: <UserProfile />,
              },
              {
                path: rootPaths.eligibilityRoot,
                element: (
                  <>
                    <eligibilityRoot />
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <EligibilityCheck />,
                  },
                  {
                    path: paths.eligibilityCheck,
                    element: <EligibilityCheck />,
                  },
                  {
                    path: `${paths.eligibilityCheck}/:id`,
                    element: <EliglibilityResposne />, // Corrected typo
                  },
                  {
                    path: paths.eligibilityCheckList,
                    element: <EligibilityCheckList />,
                  },
                ],
              },
              {
                path: rootPaths.preauthorizationRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <Preauthorization />,
                  },
                  {
                    path: paths.preauthorization,
                    element: <Preauthorization />,
                  },
                  {
                    path: paths.preauthorizationList,
                    element: <PrauthorizationList />,
                  },
                  {
                    path: `/${rootPaths.preauthorizationRoot}/preauthorization-list/view/:id`,
                    element: <PrauthorizationView />,
                  },
                ],
              },
              {
                path: rootPaths.claimsRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <Cliams />,
                  },
                  {
                    path: paths.claimsList,
                    element: <Cliams />,
                  },
                  {
                    path: `${paths.createClaim}/:id`,
                    element: <CreateClaim />,
                  },
                  {
                    path: `${paths.createClaim}`,
                    element: <CreateClaim />,
                  },
                  {
                    path: `${paths.viewClaimRequest}/:id`,
                    element: <ClaimViewRequest />,
                  },
                  {
                    path: `${paths.viewClaimResponse}/:id`,
                    element: <CliamViewResponse />,
                  },
                  {
                    path: `${paths.preapareClaim}`,
                    element: <PrepareClaim />,
                  },
                  {
                    path: `${paths.claimDashboard}`,
                    element: <ClaimDashboard />,
                  },
                  {
                    path: paths.cliamPollsImports,
                    element: <ClaimImport />,
                  },
                  {
                    path: paths.cliamPolls,
                    element: <ClaimPolls />,
                  },
                  {
                    path: paths.payment,
                    element: <PaymentList />,
                  },
                ],
              },

              {
                path: rootPaths.communicationRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <>communication</>,
                  },
                  {
                    path: paths.communicationSolicited,
                    element: <>communication solicited</>,
                  },
                  {
                    path: paths.communicationUnsolicited,
                    element: <>communication unsolicited</>,
                  },
                ],
              },
              {
                path: rootPaths.billingRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <>Billing Invoice List</>,
                  },
                  {
                    path: paths.billingInvoicesList,
                    element: <>Billing Invoice List</>,
                  },
                ],
              },
              {
                path: rootPaths.practitionerRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <Practitioners />,
                  },
                  {
                    path: paths.practitionerList,
                    element: <Practitioners />,
                  },
                  {
                    path: `${paths.addPractitionerList}/:id`,
                    element: <AddPractitioner />,
                  },
                  {
                    path: `${paths.addPractitionerList}/:id/view`,
                    element: <AddPractitioner view={true} />,
                  },
                  {
                    path: paths.addPractitionerList,
                    element: <AddPractitioner />,
                  },
                  {
                    path: paths.practitionerImports,
                    element: <PractitonerImport />,
                  },
                ],
              },
              {
                path: rootPaths.priceRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <PriceList />,
                  },
                  {
                    path: paths.priceList,
                    element: <PriceList />,
                  },
                  {
                    path: paths.addPriceList,
                    element: <AddPrice />,
                  },
                  {
                    path: `${paths.addPriceList}/:id`,
                    element: <AddPrice />,
                  },
                  {
                    path: paths.priceImport,
                    element: <PriceImport />,
                  },
                ],
              },
              {
                path: rootPaths.patientRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <Patient />,
                  },
                  {
                    path: paths.patientList,
                    element: <Patient />,
                  },
                  {
                    path: paths.viewPatient(":id"),
                    element: <PatientView />,
                  },
                ],
              },
              {
                path: rootPaths.employeeRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <EmpolyeeList />,
                  },
                  {
                    path: paths.employeeList,
                    element: <EmpolyeeList />,
                  },
                  {
                    path: paths.addEmpolyeeList,
                    element: <AddEmpolyee />,
                  },
                  {
                    path: `${paths.addEmpolyeeList}/:id`,
                    element: <AddEmpolyee />,
                  },
                  {
                    path: `${paths.addEmpolyeeList}/:id/view`,
                    element: <AddEmpolyee view={true} />,
                  },
                  {
                    path: paths.employeeImport,
                    element: <EmpolyeeImport />,
                  },
                ],
              },
              {
                path: rootPaths.insuranceCompanyRoot,
                element: <InsuranceCompanyList />,
              },
              {
                path: rootPaths.userPermissionsRoot,
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <UserPermissionList />,
                  },
                  {
                    path: paths.userPermissionList,
                    element: <UserPermissionList />,
                  },
                  {
                    path: `${paths.editPermission}/:id`,
                    element: <EditUserPermission />,
                  },
                ],
              },
              {
                path: rootPaths.reportsRoot,
                element: <>Reports</>,
              },
              {
                path: rootPaths.generalSettingsRoot, // "general-settings"
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <>General Settings</>,
                  },
                  {
                    path: "branch-list", // ✅ /general-settings/branch-list
                    element: <BranchList />,
                  },
                  {
                    path: "add-branch", // ✅ /general-settings/branch-list
                    element: <AddBranch />,
                  },
                  {
                    path: "add-branch/:id", // ✅ /general-settings/branch-list
                    element: <AddBranch />,
                  },
                  {
                    path: "add-branch/:id/view", // ✅ /general-settings/branch-list
                    element: <AddBranch view={true} />,
                  },
                  {
                    path: "import-branch", // ✅ /general-settings/import-branch
                    element: <BranchImport />,
                  },
                  {
                    path: "system-privillage",
                    element: <SystemPrivillageMain />,
                  },
                  {
                    path: `${paths.systemPrivillage}/add`,
                    element: <AddUpdateRole />,
                  },
                  {
                    path: `${paths.systemPrivillage}/add/:id`,
                    element: <AddUpdateRole />,
                  },
                  {
                    path: `${paths.systemPrivillage}/add/:id/view`,
                    element: <AddUpdateRole view={true} />,
                  },
                  {
                    path: "field-settings", // ✅ /general-settings/field-settings
                    element: <FieldSettings />,
                  },
                  {
                    path: "icds-code-settings", // ✅ /general-settings/icds-code-settings
                    element: <>ICDs Code Settings</>,
                  },
                ],
              },
            ],
          },

          // Alternative layouts
          {
            path: "/",
            element: <VerticalNavLayout />,
            children: [
              {
                path: paths.verticalNavLayout,
                element: <Dashboard />,
              },
            ],
          },
          {
            path: "/",
            element: <TopNavLayout />,
            children: [
              {
                path: paths.topNavLayout,
                element: <Dashboard />,
              },
            ],
          },
          {
            path: "/",
            element: <ComboNavLayout />,
            children: [
              {
                path: paths.comboNavLayout,
                element: <Dashboard />,
              },
            ],
          },
          {
            path: "/",
            element: <DoubleTopNavLayout />,
            children: [
              {
                path: paths.doubleTopNavLayout,
                element: <Dashboard />,
              },
              {
                path: "eligibility",
                element: <eligibilityRoot />,
                children: [
                  {
                    index: true,
                    element: <h1>Eligibility Check</h1>,
                  },
                  {
                    path: paths.eligibilityCheck,
                    element: <h1>Eligibility Check</h1>,
                  },
                  {
                    path: paths.eligibilityCheckList,
                    element: <h1>Eligibility Check List</h1>,
                  },
                ],
              },
              {
                path: rootPaths.preauthorizationRoot,
                element: (
                  <>
                    <Outlet />
                  </>
                ),
                children: [
                  {
                    index: true,
                    element: <>preauthorization</>,
                  },
                  {
                    path: paths.preauthorization,
                    element: <>preauthorization</>,
                  },
                  {
                    path: paths.preauthorizationList,
                    element: <>preauthorization list</>,
                  },
                ],
              },
            ],
          },
        ],
      },

      // Catch-all route
      {
        path: "*",
        element: <Navigate to={paths.error404} replace />,
      },
    ],
  },
];

// In your router configuration file
export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL,
});

export default routes;
